import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "configurator-pick-a-card-footer" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("button", {
      class: "configurator-pick-a-card-footer__button",
      type: "button",
      onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($setup.emits('skipCardSelection')), ["prevent"]))
    }, _toDisplayString($props.label), 1 /* TEXT */)
  ]))
}